import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, change } from 'redux-form';
import { deepDiver } from 'helpers/utilities';

import PermissionFields from './PermissionFields';
import RolesFields from './RolesFields';

class PermissionForm extends React.Component {
  onPermissionFieldChange = () => {
    this.props.changeFormValue(this.props.formName, 'role', 'custom');
  };

  onRoleFieldChange = (event, value) => {
    const role = (this.props.roles || []).filter(role => role.value === value)[0];
    if (deepDiver(role, 'permissions')) {
      Object.keys(role.permissions).forEach(permissionKey => {
        this.props.changeFormValue(
          this.props.formName,
          permissionKey,
          role.permissions[permissionKey]
        );
      });
    }
  };

  render() {
    if (this.props.isOnlyApiUser) return;
    window.dispatchEvent(new Event('resize'));

    return (
      <form onSubmit={this.props.handleSubmit}>
        <RolesFields roles={this.props.roles} onChange={this.onRoleFieldChange} />
        <PermissionFields
          onChange={this.onPermissionFieldChange}
          showMessaging={this.props.showMessaging}
        />
      </form>
    );
  }
}

export default compose(
  connect(
    (store, ownProps) => ({
      form: ownProps.formName,
      roles: store.landlordUsers.roles,
      showMessaging: store.userTypes.showMessaging,
    }),
    {
      changeFormValue: change,
    }
  ),
  reduxForm({
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(PermissionForm);
